import React from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';

import asyncComponent from '../../../util/asyncComponent';


const OTA = ({match}) => (
    <div className="app-wrapper">
        <Switch>
            <Redirect exact from={`${match.url}/`} to={`${match.url}/customer`}/>
            <Route path={`${match.url}/customer`} component={asyncComponent(() => import('./routes/CustomerGroup'))}/>
            <Route path={`${match.url}/target-ota`} component={asyncComponent(() => import('./routes/TargetOta'))}/>
            <Route path={`${match.url}/target-otl-otd`} component={asyncComponent(() => import('./routes/TargetOtlOtd'))}/>
            <Route path={`${match.url}/report-ota`} component={asyncComponent(() => import('./routes/ReportOta'))}/>
            <Route path={`${match.url}/report-otl-otd`} component={asyncComponent(() => import('./routes/ReportOtlOtd'))}/>
            <Route path={`${match.url}/report-ota-distance`} component={asyncComponent(() => import('./routes/ReportOtaDistance'))}/>
            <Route component={asyncComponent(() => import('components/Error404'))}/>
        </Switch>
    </div>
);

export default OTA;


// WEBPACK FOOTER //
// ./app/routes/OTA/index.js